module.exports = __webpack_public_path__ + "img/vip-coupon.3952e090.png";